import {useMutation, useQuery} from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";
import {handleResponse, queryClient} from "../setup";
import Noti from "../../../view/components/general/noti";
import {DraftPrescriptionService} from "../../../services/requests/visit/draftPrescription";

const useGetDraftPrescriptionList = (params: any, modalName: boolean) => {
  return useQuery({
    queryKey: ["getDraftPrescriptionList", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return DraftPrescriptionService.getDraftPrescriptionList(params);
    },
    enabled: modalName ?? true,
  });
}

const useGetDraftPrescription = () => {
  return useMutation({
    mutationFn: DraftPrescriptionService.getDraftPrescription,
  })
}

const useAddDraftPrescription = ({
 onSuccess
}: {
  onSuccess: () => void
}) => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: DraftPrescriptionService.addDraftPrescription,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getDraftPrescriptionList"] })
          onSuccess();
        }
      })
    },
  })
}

const useDeleteDraftPrescription = ({
  onSuccess
}: {
  onSuccess: () => void
}) => {
  return useMutation({
    mutationFn: DraftPrescriptionService.deleteDraftPrescription,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getDraftPrescriptionList"] })
          onSuccess();
        }
      })
    },
    onError: (error) => {
      Noti("error", error?.message)
    }
  })
}

export {
  useGetDraftPrescriptionList,
  useGetDraftPrescription,
  useAddDraftPrescription,
  useDeleteDraftPrescription
}
